import React, {useEffect, useRef} from 'react';
import {AppState} from 'react-native';

import RecordsScreen from '/component/layout/RecordsScreen';
import {useTranslation} from '/provider/TranslationProvider';

import {AllReferralsContent} from './AllReferralsContent';
import reportPayload from './reportPayload';

interface AllReferralReportProps {
  resetReferralReportData: any;
  loadingData: any;
}

export const AllReferralsReport: React.FC<AllReferralReportProps> = props => {
  const {resetReferralReportData, loadingData} = props;
  const {ts} = useTranslation('report.allReferral');
  const appState = useRef(AppState.currentState);

  useEffect(() => {
    const subscription = AppState.addEventListener('change', nextAppState => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === 'active'
      ) {
        resetReferralReportData();
      }

      appState.current = nextAppState;
    });

    return () => {
      subscription.remove();
    };
  }, []);

  return (
    <RecordsScreen
      {...reportPayload}
      contentComponent={AllReferralsContent}
      title={ts('title', 'Referrals')}
      isTopLineTitle={true}
      showFeedback={false}
      showAddCandidateButton={false}
      contentProps={{loadingData}}
      {...props}
    />
  );
};
